import { styled } from '@mui/material/styles'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useActivating, useZkexConnecting } from 'store/account/hooks'
import { useLinkConnecting } from 'store/link/hooks'
import { ActionButton } from './ActionButton'
import { updateModal } from '../../store/app/actions/modalActions'
import { useWeb3Connected, useWeb3Connecting } from '../../store/web3/hooks'
import { useGuideText } from 'store/app/hooks'

export const ConnectButtonWrap = styled(ActionButton)`
  font-size: 16px;
  border-radius: 50px;
`
ConnectButtonWrap.defaultProps = {
  variant: 'contained',
  fullWidth: true,
}
export const ConnectWalletButton = memo(() => {
  const activating = useActivating()
  const dispatch = useDispatch()
  const web3Connected = useWeb3Connected()
  const web3Connecting = useWeb3Connecting()
  const linkConnecting = useLinkConnecting()
  const zkexConnecting = useZkexConnecting()
  const guideText = useGuideText()

  const connecting =
    activating || web3Connecting || linkConnecting || zkexConnecting
  return (
    <ConnectButtonWrap
      loading={connecting}
      disabled={connecting}
      onClick={() => {
        dispatch(updateModal({ modal: 'wallets', open: true }))
      }}
    >
      {guideText
        ? guideText
        : web3Connected
          ? 'Connect ZKEX'
          : 'Connect Wallet'}
    </ConnectButtonWrap>
  )
})
